var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocaPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.36364C7.99091 6.36364 6.36364 7.99091 6.36364 10C6.36364 12.0091 7.99091 13.6364 10 13.6364C12.0091 13.6364 13.6364 12.0091 13.6364 10C13.6364 7.99091 12.0091 6.36364 10 6.36364ZM18.1273 9.09091C17.7091 5.3 14.7 2.29091 10.9091 1.87273V0H9.09091V1.87273C5.3 2.29091 2.29091 5.3 1.87273 9.09091H0V10.9091H1.87273C2.29091 14.7 5.3 17.7091 9.09091 18.1273V20H10.9091V18.1273C14.7 17.7091 17.7091 14.7 18.1273 10.9091H20V9.09091H18.1273ZM10 16.3636C6.48636 16.3636 3.63636 13.5136 3.63636 10C3.63636 6.48636 6.48636 3.63636 10 3.63636C13.5136 3.63636 16.3636 6.48636 16.3636 10C16.3636 13.5136 13.5136 16.3636 10 16.3636Z",
    fill: "#B9B5AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocaPic);
export default __webpack_public_path__ + "static/media/loca-pic.39f58e7eb3a679b3a0c7907e9d02f6c5.svg";
export { ForwardRef as ReactComponent };